"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTime = void 0;
function validateTime(time) {
    if (typeof time !== 'string')
        return false;
    return /(((^0?[1-9])|(^1[0-2])):([0-5])([0-9])\s(A|P)M)$/i.test(time);
}
exports.validateTime = validateTime;
//# sourceMappingURL=validateTime.js.map